import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SetPasswordView } from '@/platform/auth/SetPasswordView';

const setPasswordSearch = z.object({
   token: z.string().min(1).optional().catch(undefined),
   email: z.email().optional().catch(undefined),
   error: z.string().max(100).optional().catch(undefined)
});

export const Route = createFileRoute('/set-password')({
   validateSearch: setPasswordSearch,
   component: SetPasswordView
});
